var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.984 1.801L.743 6.958l5.241 5.156M1.168 6.998h9.323"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTIgMTMiPgogICAgPGcgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuMDAwMDAwLCA2LjUwMDAwMCkgcm90YXRlKDkwLjAwMDAwMCkgdHJhbnNsYXRlKC02LjAwMDAwMCwgLTYuNTAwMDAwKSB0cmFuc2xhdGUoMC4wMDAwMDAsIDEuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuMjgxMTUzLCA1Ljc1NzM5Mikgcm90YXRlKC05MC4wMDAwMDApIHRyYW5zbGF0ZSgtNi4yODExNTMsIC01Ljc1NzM5MikgdHJhbnNsYXRlKDEuMjgxMTUzLCAwLjI1NzM5MikiPgogICAgICAgICAgICAgICAgPHBvbHlsaW5lIHBvaW50cz0iNS4yNDE0OTMzNyAwLjUyMDI2Mzc3OSAtMS40ODk0OTMxMWUtMTcgNS42NzY1MTM3OCA1LjI0MTQ5MzM3IDEwLjgzMjc2MzgiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMC40MjU4Njk2Niw1LjcxNjU4Mzg3IEw5Ljc0ODg3NDg0LDUuNzE2NTgzODciIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgBackArrow as ReactComponent };